/*@ngInject*/
const DragModel = function () {

    let currentDragConfig;

    this.getCurrentDragItem = function () {
        return currentDragConfig;
    };

    this.setCurrentDragItem = function (newDragCongig) {
        currentDragConfig = newDragCongig;
    };
};

angular.module('umFormViewer').service('dragModel', DragModel);
